import logo from "../../assets/images/logos/Logo_Artbanne.png"
import logoWhite from "../../assets/images/logos/Logo_Artbanne_blanc.png"

export default function Logo({ width, height, color = "dark" }) {
    return (
        <img src={color === "dark" ? logo : logoWhite} width={width} height={height} style={{ maxHeight: height }} alt="Logo de L'Artbanne long" />
    )
};